import { useParams } from "react-router-dom";
import { SharedInterfaceMonthlyReports } from "./sharedInterface";

export type MonthlyReportsTabProps = {
  canGenerateReports: boolean;
};

export const MonthlyReportsTab = ({
  canGenerateReports,
}: MonthlyReportsTabProps) => {
  const params = useParams();

  if (params.tab !== "monthly_reports") {
    return;
  }

  return (
    <SharedInterfaceMonthlyReports canGenerateReports={canGenerateReports} />
  );
};
